module.exports = __webpack_public_path__ + "img/2ezBanner1Mobile.b5ed2b6a.jpg";